import { Stack } from "@mui/material";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

export function NewsFeedErrorPageState() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={8}
      flexGrow={1}
      textAlign="center"
      sx={{ textWrap: "balance" }}
    >
      <Illustration type="error" />
      <Text variant="body1">Error loading your news feed...</Text>
    </Stack>
  );
}
